import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://igkjllgilryyxayatqgb.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlna2psbGdpbHJ5eXhheWF0cWdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA5MDY0ODUsImV4cCI6MjA5NjQ4MjQ4NX0.LTsdC9zo3HSCWpOp_xwEKx4WCZFnVWwtaKqIM-D9xRs'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Profile = {
  id: string
  name: string | null
  religion: string | null
  belief: string | null
  avatar_url: string | null
  created_at: string
  updated_at: string
}

export type UserSettings = {
  id: string
  user_id: string
  openrouter_key: string | null
  theme: string
  created_at: string
  updated_at: string
}

export type ChatSession = {
  id: string
  user_id: string
  mode: 'learning' | 'debating'
  title: string
  created_at: string
  updated_at: string
}

export type ChatMessage = {
  id: string
  session_id: string
  role: 'user' | 'assistant' | 'system'
  content: string
  thinking: string | null
  artifacts: any
  pipeline_info: any
  model: string | null
  created_at: string
}
